import { render, staticRenderFns } from "./preWrap-editor.vue?vue&type=template&id=59314680&scoped=true"
import script from "./preWrap-editor.vue?vue&type=script&lang=js"
export * from "./preWrap-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59314680",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59314680')) {
      api.createRecord('59314680', component.options)
    } else {
      api.reload('59314680', component.options)
    }
    module.hot.accept("./preWrap-editor.vue?vue&type=template&id=59314680&scoped=true", function () {
      api.rerender('59314680', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-static-text/preWrap-editor.vue"
export default component.exports